import React from "react";
import { IDataMultipleContextProvider } from "./types";

export const defaultDataProvider = () => {
  return {
    default: () => ({
      authenticate: () => Promise.resolve(),
      getList: () => Promise.resolve({ data: [], total: 0 }),
      getOne: () => Promise.resolve({ data: { Id: 1 } }),
      create: () => Promise.resolve({ data: { id: 1 } }),
      update: () => Promise.resolve({ data: { id: 1 } }),
      delete: () => Promise.resolve({ data: { id: 1 } }),
      custom: () => Promise.resolve({ data: {} }),
      upload: () => Promise.resolve({ data: {} }),
      download: () => Promise.resolve({ data: {} }),
      getApiUrl: () => "",
    }),
  };
};

export const DataContext = React.createContext<
  IDataMultipleContextProvider | undefined
>(defaultDataProvider() as IDataMultipleContextProvider);

export const DataContextProvider: React.FC<
  React.PropsWithChildren<{ providers?: IDataMultipleContextProvider }>
> = ({ children, providers }) => {
  return (
    <DataContext.Provider value={providers}>{children}</DataContext.Provider>
  );
};
